import React from 'react';
import { faExclamation } from '@fortawesome/free-solid-svg-icons';
import { ClosingDateNotice } from './ClosingDateNotice';

export const ClosingDateUnresolvedWarning = () => (
    <ClosingDateNotice
        tone="warning"
        icon={faExclamation}
        className="closing-date-unresolved-warning">
        <strong>Unresolved items in the Flow of Funds.</strong> There are
        outstanding line items in the Flow of Funds that should be reviewed and
        resolved before this engagement is closed.
    </ClosingDateNotice>
)
